export const openInNewWindow = (url: string) =>
  window.open(url, '_blank', 'noopener,noreferrer');
